import { icsApi } from './api';

interface Params {
  url: string;
  body?: object;
  contentType?: string;
}

const emptyObject = {} as const;

export async function patch({
  url,
  body = emptyObject,
  contentType = 'application/json',
}: Params): Promise<{ message: string }> {
  const axiosResponse = await icsApi.patch(url, body, {
    headers: {
      'Content-Type': contentType,
    },
  });

  if (axiosResponse.status !== 200) {
    throw new Error(axiosResponse.data.error.message);
  }

  return { message: 'OK' };
}
